import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { ProprieteState } from './propriete/propriete.state';
import { PersonneState } from './shared/personne.state';
import { PreferencesState } from './shared/preferences.state';
import { NavigationState } from './shared/navigation.state';
import { OctroiState } from './octroi/octroi.state';
import { NotificationState } from './notification/notification.state';
import { environment } from '../environments/environment';
import { ToolCapaciteStateModule } from './tool-capacite/tool-capacite-state.module';
import { ToolPreautorisationStateModule } from './tool-preautorisation/tool-preautorisation-state.module';

const states = [PersonneState, NavigationState, ProprieteState, OctroiState, PreferencesState, NotificationState];

@NgModule({
  imports: [
    ToolCapaciteStateModule,
    ToolPreautorisationStateModule,
    NgxsModule.forRoot(states, {
      compatibility: {
        strictContentSecurityPolicy: true
      }
    }),
    NgxsReduxDevtoolsPluginModule.forRoot({
      disabled: environment.production
    })
  ]
})
export class AppStateModule {}
